import { useCallback, useLayoutEffect, useState } from 'react';
export var ElementEdge;

(function (ElementEdge) {
  ElementEdge["Left"] = "left";
  ElementEdge["Right"] = "right";
  ElementEdge["Top"] = "top";
  ElementEdge["Bottom"] = "bottom";
})(ElementEdge || (ElementEdge = {}));

export var useElementEdgeInView = function useElementEdgeInView(elementEdge, element, scrollableContainer) {
  var isElementInView = useCallback(function () {
    var containerPosition = element == null ? void 0 : element.getBoundingClientRect();
    var scrollableContainerPosition = scrollableContainer == null ? void 0 : scrollableContainer.getBoundingClientRect();

    if (!containerPosition) {
      return false;
    }

    switch (elementEdge) {
      case ElementEdge.Bottom:
        return containerPosition.bottom >= 0 && containerPosition.bottom <= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.bottom) || window.innerHeight || document.documentElement.clientHeight) && containerPosition.bottom >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.top) || 0);

      case ElementEdge.Top:
        return containerPosition.top >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.top) || 0);

      case ElementEdge.Left:
        return containerPosition.left >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.left) || 0);

      case ElementEdge.Right:
        return containerPosition.right >= 0 && containerPosition.right <= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.width) || window.innerWidth || document.documentElement.clientWidth) && containerPosition.right >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.right) || 0);

      default:
        return true;
    }
  }, [element, elementEdge, scrollableContainer]);

  var _useState = useState(),
      elementInView = _useState[0],
      setElementInView = _useState[1];

  useLayoutEffect(function () {
    setElementInView(isElementInView());

    var handleScrollPositionChange = function handleScrollPositionChange() {
      setElementInView(isElementInView());
    };

    window.addEventListener('resize', handleScrollPositionChange);
    scrollableContainer == null ? void 0 : scrollableContainer.addEventListener('scroll', handleScrollPositionChange);
    return function () {
      window.removeEventListener('resize', handleScrollPositionChange);
      scrollableContainer == null ? void 0 : scrollableContainer.removeEventListener('scroll', handleScrollPositionChange);
    };
  }, [element, scrollableContainer, isElementInView]);
  return elementInView;
};